export enum UnleashFeatures {
  EDITOR_REACT = 'editor-react-portals',
  EDITOR_MODE_EDIT = 'edit-mode-portals',
  PORTAL_ALFA_FEATURES = 'portal-alfa-features',
  PORTAL_BETA_FEATURES = 'portal-beta-features',
  PORTAL_WHITE_LABEL = 'portal-white-label',
  PORTAL_DEEP_CUSTOMIZATION = 'portal-deep-customization',
  BOOK_DEMO_FORM = 'book-demo-form',
  TASKS_CALENDAR = 'tasks-calendar',
  CHAT_HELPER_BUTTONS = 'chat-helper-buttons',
  DASHBOARD = 'dashboard',
  FILE_MANAGER = 'file-manager',
  IMAGE_VIEWER = 'image-viewer',
  FROM_CALL_UPGRADE = 'booking-flow-upgrade-popup',
  FROM_CALL_PASTDUE = 'booking-flow-pastdue-popup',
  DUPLICATE_FOLDER = 'duplicate-folder',
  NOTIFICATION_PANEL = 'notification-panel',
  FROM_CALL_UPGRADE_FREE = 'booking-flow-upgrade-free',
  FROM_CALL_UPGRADE_PAID = 'booking-flow-upgrade-paid',
  PORTAL_MANAGE_PERMISSIONS = 'portal-manage-permissions',
  KANBAN_CALENDAR = 'kanban-calendar',
  DASHBOARD_CALENDAR = 'dashboard-calendar',
  RATE_THE_EDITOR = 'rate-the-editor',
  PORTAL_TASKS_DASHBOARD = 'portal-tasks-dashboard',
  CHAT_DASHBOARD = 'chat-dashboard',
  CHAT_NOTIFICATIONS = 'chat-notifications',
  PORTAL_NOTIFICATION_PANEL = 'portal-notification-panel',
  NOTIFICATION_PANEL_FILTER = 'notification-panel-filter',
  SIDEBAR_TRUNCATE_LONG_CHILDREN = 'sidebar-truncate-long-children',
  PORTAL_MOBILE_NOTIFICATIONS = 'portals-mobile-notifications',
  VIDEO_GUIDES = 'video-guides',
  PORTAL_ANALYTICS = 'portal-analytics',
  USER_MENU_WHITE_LABEL = 'user-menu-white-label',
  PDF_ESIGN = 'pdf-esign',
  SHOW_DISCOUNT_ACTION = 'show-discount-action',
  AI_ASSISTANT_IN_PORTALS = 'ai-assistant-in-portals',
  SHOW_NEW_SIDEBAR = 'show-new-sidebar',
  HIDE_OLD_SIDEBAR = 'hide-old-sidebar',
  PDF_VIEWER = 'pdf-viewer',
  BEAMER = 'beamer',
  NOTE_TAGS = 'note-tags',
  AI_ASSISTANT_DETECT_USER_MESSAGE_CONTEXT = 'ai-assistant-detect-user-message-context',
  GENERAL_ACCESS = 'general-access',
  AI_AGENTS = 'ai-agents',
  SHOW_NAVBAR_WORKSPACES = 'show-navbar-workspaces',
  AGENT_FULLSCREEN_MODE = 'agent-fullscreen-mode',
  AI_AGENT_INTEGRATIONS = 'ai-agent-integrations',
}

export type UnleashFlags = {
  [key in UnleashFeatures]: boolean;
};

export const allUnleashFlags: Array<UnleashFeatures> = Object.values(UnleashFeatures);

export const unleashFlagsAllOn: UnleashFlags = allUnleashFlags.reduce((acc, flag) => {
  acc[flag] = true;
  return acc;
}, {} as UnleashFlags);

export const unleashFlagsAllOff: UnleashFlags = allUnleashFlags.reduce((acc, flag) => {
  acc[flag] = false;
  return acc;
}, {} as UnleashFlags);
